// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PhoneSurvey_wrapper__TzBnZ","dismiss-button":"PhoneSurvey_dismiss-button__IVlkP"};